import { SessionInputDisplayParam } from "../model";

export const SourceStartParams: Record<string, SessionInputDisplayParam> = {
  rootUrl: {
    name: "rootUrl",
    display_name: "Root URL",
    type: "text",
    desc:
      "Input the web URL of the location you wish to scan.</br> Cognni will scan all the folders and files contained as a subset of that URL.",
  },
  scanSizeLimit: {
    name: "scanSizeLimit",
    display_name: "Scan Size Limit",
    type: "number",
    desc: "",
  },
  password: {
    name: "password",
    display_name: "Password",
    type: "password",
    desc: "",
  },
};
